import Vue from 'vue'
import Router from 'vue-router'
import $store from './store';
const {menuLateral} = $store.getters;
import Page404 from './views/Page404.vue'
import Login from './views/Login.vue'
import LoginRedirect from './views/LoginRedirect.vue'
import SsoAccept from './views/SsoAccept.vue'
import SsoLogout from './views/SsoLogout.vue'
import Test from './views/Test.vue'

Vue.use(Router)
const defaultRoutes = [
  { path: '*', component: Page404 },   
  {
    path: '/test',
    name: 'test',
    component: Test,
  },
  {
    path: '/login',
    name: 'login',
    component: LoginRedirect,
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/old_login',
    name: 'old_login',
    component: Login,
    meta: {
      layout: 'blank',
    },
    beforeEnter(to, from, next) {
      const isLocalAc = window.location.host === 'localhost:8080';
      if (isLocalAc) return next();
      next({ name: 'login' });
    },
  },
  {
    path: '/sso/accept',
    name: 'sso_accept',
    component: SsoAccept,
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/sso/logout',
    name: 'sso_logout',
    component: SsoLogout,
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/',
    redirect: '/home',
  },
]
const createRoutes = (menus, module_name = '') => {
  let rs = []
  menus.forEach(menu => {
    // External links (href) are navigation-only; no Vue route/component needed
    if (menu.href) {
      if (menu.children && menu.children.length) {
        rs = rs.concat(createRoutes(menu.children, module_name || menu.module));
      }
      return;
    }

    //if (!menu.component) console.warn('NO SE HA DEFINIDO COMPONENETE PARA ' + menu.id, menu)
    
    const m = {path:`/${menu.id}`, name:menu.id, component: () => import(`./modules/${module_name || menu.module}/views/${menu.id}/index.vue`)};
    if (menu.redirect) m.redirect = menu.redirect;
    if (menu.tabs && menu.tabs.length) {

      m.redirect = `/${menu.tabs[0].id}`;
      m.children = [];
      menu.tabs.forEach(tab => {
        const n = tab.id.lastIndexOf('/');
        const path = tab.id.slice(0, n) + tab.id.slice(n).replace('/', '/tabs/');
        tab.component = () => import(`./modules/${module_name || menu.module}/views/${path}.vue`);

        if (!tab.component) console.warn('NO SE HA DEFINIDO COMPONENETE PARA ' + tab.id, tab);
        const tab_params = tab.params? tab.params.map(tp=>`/:${tp}`).join(''): '';
        m.children.push({
          path: `/${tab.id}${tab_params}`,
          name: tab.id,
          component: tab.component,
        })
      })
    } // tabs
    if (menu.children && menu.children.length) {
      rs = rs.concat(createRoutes(menu.children, module_name || menu.module));
    }
    rs.push(m)
  })
  return rs;
}
const menu_router = createRoutes(menuLateral);

const routes = defaultRoutes.concat(menu_router);


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})
router.beforeEach((to, from, next) => {
  next();
})
const originalPush = router.push;
router.push = function( ...args ) {
	return originalPush.call( this, ...args )
    .then(t => $store.dispatch('close_dialog'))
    .catch( error => {
      error
        ? console.warn( `consumed router exception: ${error}` )
        : console.warn( `consumed unknown router exception ${new Error().stack.replace( /^[\s\S]+?at/, "at" )}` );
	  });
};
export default router;
